'use strict';

/*global isEmpty*/
/*global services*/

function DevelopmentTools() {
    this.$pageErrorMsg = null;
    this.savedInfoTimeout = null;
    this.mostRecentCalls = null;

    this.init();
}

DevelopmentTools.prototype = $.extend({}, {
    construtor: 'DevelopmentTools',

    //**************************************************************************
    removeLastFinishCalls: function removeLastFinishCalls() {
        var _this = this;

        var saveLastFinishCalls = 4;
        if(_this.mostRecentCalls.length > saveLastFinishCalls) {
            var finishCalls = 0;
            $.each(_this.mostRecentCalls, function (key, value) {
                if(value.jqXHR.readyState === 4) {
                    finishCalls++;
                }
            });
            while(finishCalls >= saveLastFinishCalls) {
                _this.mostRecentCalls.shift();
                finishCalls--;
            }
        }
    },

    convertAjaxToLog: function convertAjaxToLog(mostRecentCalls) {
        var log = '';
        $.each(mostRecentCalls, function (key, item) {
            log += '..' + item.time + '.....................\r\n';
            if(item.settings) {
                log += 'time = ' + item.time + ';\r\n';
                log += 'url = "' + item.settings.url + '";\r\n';
                log += 'data = "' + item.settings.data + '";\r\n';
            }
            if(item.jqXHR) {
                log += 'statusText = "' + item.jqXHR.statusText + '";\r\n';
                log += 'responseText = "' + (item.jqXHR.responseText ? item.jqXHR.responseText.substring(0, 500) : item.jqXHR.responseText) + '";\r\n';
                log += 'readyState = "' + item.jqXHR.readyState + '";\r\n';
            }
            log += '.........................................\r\n';
        });
        return log;
    },

    convertToText: function convertToText(obj) {
        var string = [];
        var prop;

        if (typeof(obj) === 'object' && (obj.join === undefined)) {
            string.push('{');

            for (prop in obj) {
                if (prop) {
                    string.push(prop, ': ', convertToText(obj[prop]), ',');
                }
            }
            string.push('}');

        //is array
        } else if (typeof(obj) === 'object' && obj.join !== undefined) {
            string.push('[');

            for(prop in obj) {
                if(prop) {
                    string.push(convertToText(obj[prop]), ',');
                }
            }
            string.push(']');

        //is function
        } else if (typeof(obj) === 'function') {
            string.push(obj.toString());

        //all other values can be done with JSON.stringify
        } else {
            string.push(JSON.stringify(obj));
        }

        return string.join('') + '\r\n';
    },

    sendAjaxLog: function sendAjaxLog(log) {
        $.postCORS('/?method=js_send_js_log', { log: log });
    },

    viewPageErrorMsg: function viewPageErrorMsg(res, e) {
        var _this = this;
        _this.$pageErrorMsg.show();

        var stack = new Error().stack;
        var log = '';
            log += '--------------------RES----------------------\r\n';
            log += _this.convertToText(res) + '\r\n';
            log += '---------------------E-----------------------\r\n';
            log += String(e) + '\r\n';
            log += _this.convertToText(e) + '\r\n';
            log += '-------------PRINTING CALL STACK-------------\r\n';
            log += _this.convertToText(stack) + '\r\n';
            log += '--------------------AJAX---------------------\r\n';
            log += _this.convertAjaxToLog(_this.mostRecentCalls);

        _this.sendAjaxLog(log);
    },

    viewMsg: function viewMsg(title, message) {
        var modal = services.get('modal');
        modal.empty().open({
            title: title,
            content: '<p>' + message + '</p>',
            headerClass: 'bg-danger',
            height: 'auto',
            form: false
        });
    },

    buildPageErrorMsg: function buildPageErrorMsg() {
        var _this = this;

        var html = '';
        html += '<div id="pageErrorMsg">';
        html +=     '<div>';
        html +=         '<div class="icon">';
        html +=             '<i class="fa fa-frown-o"></i>';
        html +=         '</div>';
        html +=         '<h6>' + services.get('translator').trans('PageError_title') + '</h6>';
        html +=         '<div class="desc">' + services.get('translator').trans('PageError_desc') + '</div>';
        html +=         '<div class="desc">' + services.get('translator').trans('PageError_contact') + '</div>';
        html +=     '</div>';
        html += '</div>';

        _this.$pageErrorMsg = $(html);
        $('body').append(_this.$pageErrorMsg);
    },

    //**************************************************************************
    init: function init() {
        var _this = this;

        _this.buildPageErrorMsg();

        _this.mostRecentCalls = [];
        $(document).ajaxSend(function (ev, jqXHR, settings) {
            var now = new Date();
            _this.mostRecentCalls.push({ ev: ev, jqXHR: jqXHR, settings: settings, time: now.getTime() });
            _this.removeLastFinishCalls();
        });

        return _this;
    }
});
